import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://conexusglobalconsulting.com';

const languageMap: Record<string, { hreflang: string; label: string }> = {
  en: { hreflang: 'en', label: 'English' },
  pt: { hreflang: 'pt-BR', label: 'Português' },
  es: { hreflang: 'es', label: 'Español' },
  fr: { hreflang: 'fr', label: 'Français' },
  it: { hreflang: 'it', label: 'Italiano' },
  zh: { hreflang: 'zh-CN', label: '中文' },
};

const SEOLanguageHead = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.split('-')[0] || 'en';
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';

  useEffect(() => {
    document.documentElement.lang = languageMap[currentLang]?.hreflang || 'en';
  }, [currentLang]);

  return (
    <Helmet>
      {/* Hreflang alternate links for search engines */}
      {Object.entries(languageMap).map(([code, { hreflang }]) => (
        <link
          key={code}
          rel="alternate"
          hrefLang={hreflang}
          href={`${SITE_URL}${currentPath}?lng=${code}`}
        />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${currentPath}`} />

      {/* Content language meta */}
      <meta httpEquiv="content-language" content={languageMap[currentLang]?.hreflang || 'en'} />
    </Helmet>
  );
};

export default SEOLanguageHead;
